import { ScormModuleStatus } from '@zeus/index'

/**
 * Statuts d'un module SCORM : pastille et libellé. Typés sur l'enum de l'API :
 * un statut ajouté côté serveur fait échouer le typage ici, au lieu de
 * s'afficher brut.
 */
export const MODULE_STATUS_STYLES: Record<ScormModuleStatus, string> = {
  [ScormModuleStatus.READY]: 'bg-green-500/10 text-success-text',
  [ScormModuleStatus.PROCESSING]: 'bg-amber-500/10 text-warning-text',
  [ScormModuleStatus.FAILED]: 'bg-red-500/10 text-error-text',
}

export const MODULE_STATUS_KEYS: Record<ScormModuleStatus, string> = {
  [ScormModuleStatus.READY]: 'modules.status.ready',
  [ScormModuleStatus.PROCESSING]: 'modules.status.processing',
  [ScormModuleStatus.FAILED]: 'modules.status.failed',
}
